export default __webpack_public_path__ + "static/media/shield.ed4c372e.svg";